export default __webpack_public_path__ + "static/media/medium.b282d114.svg";